import { CURSOR_FOCUS, CURSOR_ANCHOR } from './whileMaintainingSelection';
export default function saveSelection(editor, selection) {
  if (selection.isUnset) return {};
  editor.moveTo(selection.end.key, selection.end.offset).insertInline(selection.end === selection.focus ? CURSOR_FOCUS : CURSOR_ANCHOR);
  editor.moveTo(selection.start.key, selection.start.offset).insertInline(selection.start === selection.anchor ? CURSOR_ANCHOR : CURSOR_FOCUS);
  var textsSnapshot = editor.value.document.getTextsAtRange(selection.moveStartToStartOfNode(editor.value.document));
  return {
    textsSnapshot: textsSnapshot
  };
}